<!-- =========================================================================================
  File Name: OrderView.vue
  Description: Order View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="orderSheet-view-tab-pay">
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">결제금액</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        {{ String(order_data.realTakeMoney).replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 원
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">실수령액</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="order_data.realTakeMoney" v-validate="'required'"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">현금영수증 발행여부</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-radio v-model="order_data.requestPublishReceipt" vs-value="0">발행안함</vs-radio>
        <vs-radio class="ml-4" v-model="order_data.requestPublishReceipt" vs-value="1">발행</vs-radio>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">상태</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-select v-model="order_data.orderStatus" class="w-full" name="item-orderStatus" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in orderStatusOptions" />
        </vs-select>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-2/3 w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="confirmSaveChanges" :disabled="!validateForm">확인</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="$router.go(-1)">취소</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { putData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      order_data: JSON.parse(JSON.stringify(this.data)),
      orderStatusOptions: [
        {
          value: 0,
          text: '주문'
        },
        {
          value: 1,
          text: '결제완료'
        },
        {
          value: 2,
          text: '배송중'
        },
        {
          value: 3,
          text: '배송완료'
        },
        {
          value: 4,
          text: '거래완료'
        }
      ]   
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    confirmSaveChanges () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '결제 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {

      if (!this.validateForm) return

      try {
        const { data } = await putData('order-pay', this.order_data)     
        console.log(data)

        this.$router.go(-1)

        this.showSaveChangesSuccess()

      } catch (error) {
        console.log(error)

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '결제 정보 수정',
        text: '저장 되었습니다.'
      })
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-order-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
